import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'lib-image-gallery',
    templateUrl: './image-gallery.component.html',
    styleUrls: ['./image-gallery.component.scss']
})
export class ImageGalleryComponent implements OnInit {
    @Input() listImageUrl?: string[];
    @Output() deleteEvent = new EventEmitter<string>();
    @Input() showDeleteIcon = true;

    constructor(
    ) {

    }

    ngOnInit(): void {

    }


    onClickEmitter(url: string) {
        this.deleteEvent.emit(url);
    }

    openImage(url: string) {
        window.open(url, '_blank');
    }

}
